// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import TrainingAcademyPage from "../pages/TrainingAcademy/TrainingAcademy";
const __wvcRoutePaths = ["/TrainingAcademyPage", "/training-academy"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["bpo-services", "bposervicespage", "get-in-touch", "getintouchpage", "home", "homepage", "our-legacy", "ourlegacypage", "post", "training-academy", "trainingacademypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<TrainingAcademyPage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<TrainingAcademyPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
